import React from 'react';
import { Box, Typography, Grid, Paper, Chip, Divider } from '@mui/material';
import InventoryAdjustmentItemDetails from './InventoryAdjustmentItemDetails';
import AuditInformation from '../AuditInformation';
import ExportDetails from '../ExportDetails';
import { getZoneNameFromZone } from '../../catalog/utils/inventory/utils';
import { InventoryAdjustment } from '../../../services/inventory/types';

interface InventoryAdjustmentDetailsProps {
  adjustment: InventoryAdjustment;
}

const InventoryAdjustmentDetails: React.FC<InventoryAdjustmentDetailsProps> = ({ adjustment }) => {
  const getTotalQuantityAdjusted = () => {
    return adjustment.inventoryAdjustmentItems.reduce(
      (total, item) => total + item.quantityAdjusted,
      0,
    );
  };

  return (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={3}>
        {/* Main Content */}
        <Grid item xs={12} md={8}>
          <Paper elevation={1} sx={{ p: 3, mb: 3 }}>
            <Typography variant="h5" gutterBottom>
              Adjustment #{adjustment.id}
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="text.secondary">
                  Warehouse Zone
                </Typography>
                <Typography variant="body1">
                  {getZoneNameFromZone(adjustment.warehouseZone) || 'N/A'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="text.secondary">
                  Adjustment Reason
                </Typography>
                <Typography variant="body1">
                  {adjustment.adjustmentReason?.description || 'N/A'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="text.secondary">
                  Total Quantity Adjusted
                </Typography>
                <Chip
                  label={`${
                    getTotalQuantityAdjusted() > 0 ? '+' : ''
                  }${getTotalQuantityAdjusted()}`}
                  color={getTotalQuantityAdjusted() > 0 ? 'success' : 'error'}
                  size="small"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="text.secondary">
                  Notes
                </Typography>
                <Typography variant="body1">{adjustment.notes || 'No notes provided'}</Typography>
              </Grid>
            </Grid>
          </Paper>

          <InventoryAdjustmentItemDetails items={adjustment.inventoryAdjustmentItems} />
        </Grid>

        {/* Sidebar */}
        <Grid item xs={12} md={4}>
          <ExportDetails exports={adjustment.inventoryAdjustmentExports} />

          <AuditInformation
            createdByUser={adjustment.createdByUser}
            createdByUserId={adjustment.createdByUserId}
            modifiedByUser={adjustment.modifiedByUser}
            modifiedByUserId={adjustment.modifiedByUserId}
            created={adjustment.created}
            modified={adjustment.modified}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default InventoryAdjustmentDetails;
